'use strict';
const handle = () => {
	mainMenu.toggle();
}
const mainMenu = {
	el : $('.menu'),
	body: $('body'),
	html  : $('html'),
	oveflow : $(`<div class="${'menuOverlow'}">`),
	toggle : function(){
		this.el.toggleClass('open');
		this.html.toggleClass('fixed');
		if (this.el.hasClass('open')) {
			this.el.after(this.oveflow);
			$('.menuOverlow').on('click', handle);
		} else {
			$('.menuOverlow').remove();
			$('.menuOverlow').off('click', handle);
		}
		
	},
	subMenuToggle: function(dataId) {
		const $this = $(`.menuList__item[data-id="${dataId}"]`);
		$(`.menuList__item[data-id="${dataId}"]`).toggleClass('open');

		$(document).on('click', function(e) {
			if ($(e.target).closest($this).length === 0) {
				$this.removeClass('open');
			} 
		})
	}
}
if($(window).width() < 1200) {
	$(document).on('click', '.js-toggleMenu', function() {
		mainMenu.toggle()
	});
	$(document).on('click', '.js-menuToggleItem', function() {
		mainMenu.subMenuToggle($(this).data('item-id'));
	});
} else {
	$('.js-menuToggleItem').hover(function() {
		mainMenu.subMenuToggle($(this).data('item-id'));
	}, function(e) {
		if(!$(e.relatedTarget).hasClass('menuSubList')) {
			mainMenu.subMenuToggle($(this).data('item-id'));
		}
	});
	$('.menuDotsItem, .menuList__item').hover(function() {
	}, function(e) {
		$('.menuDotsItem, .menuList__item').removeClass('open');
	});
}

